export default __webpack_public_path__ + "static/media/ftp.fb299cda.svg";